export const STATUS = [
   {
    value: 'Elegir un estatus',
    key: '',
  },
  {
    value: 'ACTIVO',
    key: true,
  },
  {
    value: 'INACTIVO',
    key: false,
  },
];

export const VALIDITY = [
   {
    value: 'Eligir vigencia',
    key: '',
  },
  {
    value: 'INDEFINIDA',
    key: true,
  },
  {
    value: 'DEFINIDA',
    key: false,
  },
];

//DATATABLE
export const SIZE_SELECT = [
  {
    value: '5',
    key: 5,
  },
  {
    value: '10',
    key: 10,
  },
  {
    value: '25',
    key: 25,
  },
  {
    value: '50',
    key: 50,
  },
];
